var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Channels from '../Channels/Channels';
import SideBarIcon from './SideContainer/SideBarIcon';
import SideBar from './SideContainer/SideBar';
import { createPortal } from 'react-dom';
import { MAIN } from '../../common/theme';
var SideContainer = function (_a) {
    var channels = _a.channels, _b = _a.sideBarOption, sideBarOption = _b === void 0 ? {} : _b;
    // Default value of sideBarOption
    var _c = sideBarOption.mainTitle, mainTitle = _c === void 0 ? 'Wellcome to dev-portfolio' : _c, _d = sideBarOption.mainTitleSize, mainTitleSize = _d === void 0 ? '20px' : _d, _e = sideBarOption.mainTitleColor, mainTitleColor = _e === void 0 ? 'white' : _e, _f = sideBarOption.mainTitleAlign, mainTitleAlign = _f === void 0 ? 'left' : _f, _g = sideBarOption.mainTitleBorderColor, mainTitleBorderColor = _g === void 0 ? 'white' : _g, _h = sideBarOption.backgroundColor, backgroundColor = _h === void 0 ? MAIN.MAIN_COLOR : _h, _j = sideBarOption.iconName, iconName = _j === void 0 ? 'ant-design:menu-fold-outlined' : _j, _k = sideBarOption.iconSize, iconSize = _k === void 0 ? '30px' : _k, _l = sideBarOption.iconColor, iconColor = _l === void 0 ? '#434521' : _l, _m = sideBarOption.iconMargin, iconMargin = _m === void 0 ? '0px 12px' : _m, _o = sideBarOption.itemTextColor, itemTextColor = _o === void 0 ? 'white' : _o, _p = sideBarOption.itemTextAlign, itemTextAlign = _p === void 0 ? 'left' : _p, _q = sideBarOption.itemBackgroundColor, itemBackgroundColor = _q === void 0 ? MAIN.MAIN_COLOR : _q, _r = sideBarOption.itemHoverdBackgroundColor, itemHoverdBackgroundColor = _r === void 0 ? 'black' : _r;
    var _s = useState(false), isClickedSideBarIcon = _s[0], setIsClickedSideBarIcon = _s[1];
    var _t = useState(), sideBarItems = _t[0], setSideBarItems = _t[1];
    var onClickSideBarIconHandler = function () {
        var app = document.querySelector('.App');
        if (!app)
            return;
        var $tags = Array.from(app.children);
        setSideBarItems(Array.from(Array.prototype.slice.call($tags)).reduce(function (result, $tag) {
            var _a, _b;
            var tagId = $tag.id;
            var title;
            var itemLogoName;
            try {
                if (eval(tagId)[0] === undefined)
                    throw new Error('eval(tagId) is not array');
                _a = eval(tagId), title = _a[0], itemLogoName = _a[1];
            }
            catch (err) {
                _b = [tagId, undefined], title = _b[0], itemLogoName = _b[1];
            }
            if (!$tag.id)
                return result;
            return __spreadArray(__spreadArray([], result, true), [
                {
                    tagId: tagId,
                    title: title,
                    itemLogoName: itemLogoName,
                    itemTextColor: itemTextColor,
                    itemTextAlign: itemTextAlign,
                    itemBackgroundColor: itemBackgroundColor,
                    itemHoverdBackgroundColor: itemHoverdBackgroundColor,
                },
            ], false);
        }, []));
        setIsClickedSideBarIcon(true);
    };
    useEffect(function () {
        if (isClickedSideBarIcon) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
    }, [isClickedSideBarIcon]);
    return (_jsxs(Container, { children: [_jsx(Channels, { channels: channels }), _jsx(SideBarIcon, { iconName: iconName, iconSize: iconSize, iconColor: iconColor, iconMargin: iconMargin, onClick: onClickSideBarIconHandler }), isClickedSideBarIcon &&
                createPortal(_jsx(SideBar, { mainTitle: mainTitle, mainTitleSize: mainTitleSize, mainTitleColor: mainTitleColor, mainTitleAlign: mainTitleAlign, mainTitleBorderColor: mainTitleBorderColor, sideBarItems: sideBarItems || [], isClickedSideBarIcon: isClickedSideBarIcon, backgroundColor: backgroundColor, setIsClickedSideBarIcon: setIsClickedSideBarIcon }), document.body)] }));
};
export default SideContainer;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var templateObject_1;
